import transactionStatusReportApis from '../../../apis/payments/transactionStatusReport';
import { SnackbarSeverityType } from '../../../enums';
import {
  TransactionStatusReportCsvData,
  UploadResultInfo
} from '../../../types/transactionStatusType';
import { downloadCsvFromJson } from '../../../utils/fileGeneration';

const downloadFailedTransactionStatusRecords = (
  failedRecords: TransactionStatusReportCsvData[]
): number => {
  if (!failedRecords.length) return 0;
  const headersSet = new Set<string>();
  failedRecords.forEach((row: any) =>
    Object.keys(row || {}).forEach((key) => headersSet.add(key))
  );
  const headers = Array.from(headersSet);
  const body = failedRecords.map((row: any) =>
    headers.map((header) => row[header] as any)
  );
  downloadCsvFromJson(
    'unsuccessful-transaction-status-records',
    'FailedRecords',
    { headers, body }
  );
  return failedRecords.length;
};

const processTransactionStatusUpload = async (
  file: File,
  onProgress: (percent: number) => void,
  showToast: (message: string, severity: SnackbarSeverityType) => void
): Promise<UploadResultInfo> => {
  const result =
    await transactionStatusReportApis.uploadTransactionStatusReport(
      file,
      onProgress
    );
  const failedRecords = result?.unSuccessfulRecords || [];
  if (failedRecords.length) {
    const processed = downloadFailedTransactionStatusRecords(
      failedRecords as any
    );
    showToast(
      'A csv file with unsuccessful record(s) downloaded.',
      SnackbarSeverityType.error
    );
    return {
      failedCount: processed,
      message: 'A csv file with unsuccessful record(s) downloaded.',
      severity: SnackbarSeverityType.error
    };
  }
  showToast(
    'All transactions updated successfully.',
    SnackbarSeverityType.success
  );
  return {
    failedCount: 0,
    message: 'All transactions updated successfully.',
    severity: SnackbarSeverityType.success
  };
};

export {
  downloadFailedTransactionStatusRecords,
  processTransactionStatusUpload
};
